import script from "./EVStatistic.vue?vue&type=script&lang=ts&setup=true"
export * from "./EVStatistic.vue?vue&type=script&lang=ts&setup=true"

import "./EVStatistic.vue?vue&type=style&index=0&id=0bb55330&lang=scss&scoped=true"
import "./EVStatistic.vue?vue&type=style&index=1&id=0bb55330&lang=scss"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bb55330"]])

export default __exports__